import React, { useEffect, useState } from 'react';
import { Card, Form, Button, Row, Col, Spin, Table } from 'antd';
import { wtGetFromLocalStorage } from 'src/helpers/commons/LocalStorage';
import BaseListing from 'src/BaseListings';
import { wtApiCall, wtApiPostWithContentTypeHandling } from 'src/helpers/commons/ApiWrapper';
import { lzNotifyErrorMessageFromResult } from 'src/helpers/commons/notifications';
import WidgetFiscalYearSelector from 'src/widgets/Selectors/WidgetFiscalYearSelector';

const SalesTargetReport = () => {
    const Base = new BaseListing('sales_target_report')
    const [isLoading, setIsLoading] = useState(false)
    const [form] = Form.useForm();

    const [fiscalYears, setFiscalYears] = useState([]);

    const [fiscalYearId, setFiscalYearId] = useState(0)
    const [fiscalYearName, setFiscalYearName] = useState('')
    const [salesTargetReportData, setSalesTargetReportData] = useState([])

    const companyName = wtGetFromLocalStorage("company_name");

    // Define columns of sales target report
    const salesTargetReportHeaderColumns = [
        {
            title: <span style={{ fontSize: '0.8rem' }}>Chart Of Account</span>,
            dataIndex: 'account_name',
            key: 'account_name',
            width: 300,
            fixed: true,
            align: "left",
            render: (text, record) => (
                <span style={{
                    fontWeight: (record.key === 'total') ? 'bold' : 'normal',
                }}>
                    {text}

                </span>
            ),
        },
        {
            title: <span style={{ fontSize: '0.8rem' }}>Sales Target</span>,
            align: 'center',
            width: 400,
            children: [
                {
                    title: <span style={{ fontSize: '0.8rem' }}>Total Target (PKR)</span>,
                    dataIndex: 'total',
                    key: 'total',
                    align: 'right',
                    width: 150,
                    render: (text, record) => (
                        <span style={{
                            fontWeight: (record.key === 'total') ? 'bold' : 'normal',
                        }}>
                            {text + " M"}

                        </span>
                    ),
                },
                {
                    title: <span style={{ fontSize: '0.8rem' }}>Total Achieved (PKR)</span>,
                    dataIndex: 'quarter_total_actual_balance',
                    key: 'quarter_total_actual_balance',
                    align: 'right',
                    width: 150,
                    render: (text, record) => (
                        <span style={{
                            fontWeight: (record.key === 'total') ? 'bold' : 'normal',
                        }}>
                            {text + " M"}

                        </span>
                    ),
                },
                {
                    title: <span style={{ fontSize: '0.8rem' }}>% Achieved</span>,
                    dataIndex: 'total_percentage',
                    key: 'total_percentage',
                    align: 'right',
                    width: 100,
                    render: (text, record) => (
                        <span style={{
                            fontWeight: (record.key === 'total') ? 'bold' : 'normal',
                        }}>
                            {text + "%"}

                        </span>
                    ),
                }
            ]
        },
        {
            title: <span style={{ fontSize: '0.8rem' }}>1st Quarter</span>,
            align: 'center',
            width: 320,
            children: [
                {
                    title: <span style={{ fontSize: '0.8rem' }}>Target (PKR)</span>,
                    dataIndex: 'q1',
                    key: 'q1',
                    align: 'right',
                    width: 100,
                    render: (text, record) => (
                        <span style={{
                            fontWeight: (record.key === 'total') ? 'bold' : 'normal',
                        }}>
                            {text + " M"}

                        </span>
                    ),
                },
                {
                    title: <span style={{ fontSize: '0.8rem' }}>Achieved (PKR)</span>,
                    dataIndex: 'quarter_one_actual_balance',
                    key: 'quarter_one_actual_balance',
                    align: 'right',
                    width: 120,
                    render: (text, record) => (
                        <span style={{
                            fontWeight: (record.key === 'total') ? 'bold' : 'normal',
                        }}>
                            {text + " M"}

                        </span>
                    ),
                },
                {
                    title: <span style={{ fontSize: '0.8rem' }}>% Achieved</span>,
                    dataIndex: 'quarter_one_percentage_achieved',
                    key: 'quarter_one_percentage_achieved',
                    align: 'right',
                    width: 100,
                    render: (text, record) => (
                        <span style={{
                            fontWeight: (record.key === 'total') ? 'bold' : 'normal',
                        }}>
                            {text + "%"}

                        </span>
                    ),
                }
            ]
        },
        {
            title: <span style={{ fontSize: '0.8rem' }}>2nd Quarter (PKR)</span>,
            align: 'center',
            width: 320,
            children: [
                {
                    title: <span style={{ fontSize: '0.8rem' }}>Target (PKR)</span>,
                    dataIndex: 'q2',
                    key: 'q2',
                    align: 'right',
                    width: 100,
                    render: (text, record) => (
                        <span style={{
                            fontWeight: (record.key === 'total') ? 'bold' : 'normal',
                        }}>
                            {text + " M"}

                        </span>
                    ),
                },
                {
                    title: <span style={{ fontSize: '0.8rem' }}>Achieved (PKR)</span>,
                    dataIndex: 'quarter_two_actual_balance',
                    key: 'quarter_two_actual_balance',
                    align: 'right',
                    width: 120,
                    render: (text, record) => (
                        <span style={{
                            fontWeight: (record.key === 'total') ? 'bold' : 'normal',
                        }}>
                            {text + " M"}

                        </span>
                    ),
                },
                {
                    title: <span style={{ fontSize: '0.8rem' }}>% Achieved</span>,
                    dataIndex: 'quarter_two_percentage_achieved',
                    key: 'quarter_two_percentage_achieved',
                    align: 'right',
                    width: 100,
                    render: (text, record) => (
                        <span style={{
                            fontWeight: (record.key === 'total') ? 'bold' : 'normal',
                        }}>
                            {text + "%"}

                        </span>
                    ),
                }
            ]
        },
        {
            title: <span style={{ fontSize: '0.8rem' }}>3rd Quarter</span>,
            align: 'center',
            width: 320,
            children: [
                {
                    title: <span style={{ fontSize: '0.8rem' }}>Target (PKR)</span>,
                    dataIndex: 'q3',
                    key: 'q3',
                    align: 'right',
                    width: 100,
                    render: (text, record) => (
                        <span style={{
                            fontWeight: (record.key === 'total') ? 'bold' : 'normal',
                        }}>
                            {text + " M"}

                        </span>
                    ),
                },
                {
                    title: <span style={{ fontSize: '0.8rem' }}>Achieved (PKR)</span>,
                    dataIndex: 'quarter_three_actual_balance',
                    key: 'quarter_three_actual_balance',
                    align: 'right',
                    width: 120,
                    render: (text, record) => (
                        <span style={{
                            fontWeight: (record.key === 'total') ? 'bold' : 'normal',
                        }}>
                            {text + " M"}

                        </span>
                    ),
                },
                {
                    title: <span style={{ fontSize: '0.8rem' }}>% Achieved</span>,
                    dataIndex: 'quarter_three_percentage_achieved',
                    key: 'quarter_three_percentage_achieved',
                    align: 'right',
                    width: 100,
                    render: (text, record) => (
                        <span style={{
                            fontWeight: (record.key === 'total') ? 'bold' : 'normal',
                        }}>
                            {text + "%"}

                        </span>
                    ),
                }
            ]
        },
        {
            title: <span style={{ fontSize: '0.8rem' }}>4th Quarter</span>,
            align: 'center',
            width: 320,
            children: [
                {
                    title: <span style={{ fontSize: '0.8rem' }}>Target (PKR)</span>,
                    dataIndex: 'q4',
                    key: 'q4',
                    align: 'right',
                    width: 100,
                    render: (text, record) => (
                        <span style={{
                            fontWeight: (record.key === 'total') ? 'bold' : 'normal',
                        }}>
                            {text}

                        </span>
                    ),
                },
                {
                    title: <span style={{ fontSize: '0.8rem' }}>Achieved (PKR)</span>,
                    dataIndex: 'quarter_four_actual_balance',
                    key: 'quarter_four_actual_balance',
                    align: 'right',
                    width: 120,
                    render: (text, record) => (
                        <span style={{
                            fontWeight: (record.key === 'total') ? 'bold' : 'normal',
                        }}>
                            {text}

                        </span>
                    ),
                },
                {
                    title: <span style={{ fontSize: '0.8rem' }}>% Achieved</span>,
                    dataIndex: 'quarter_four_percentage_achieved',
                    key: 'quarter_four_percentage_achieved',
                    align: 'right',
                    width: 100,
                    render: (text, record) => (
                        <span style={{
                            fontWeight: (record.key === 'total') ? 'bold' : 'normal',
                        }}>
                            {text + "%"}

                        </span>
                    ),
                }
            ]
        },
    ];

    const changeValues = (key, val) => {

        //Set initial values
        setSalesTargetReportData([]);

        if (key === 'fiscal_year_id') {
            setFiscalYearId(val.value)
            setFiscalYearName(val.label)
        }

    }

    const print = () => {

        wtApiPostWithContentTypeHandling('reports/sales_target/print', {
            fiscal_year_id: fiscalYearId,
        });

    }

    useEffect(() => {
        Base.dropdownData('fiscal_years', {}, [setFiscalYears], 1)
    }, []);



    const getReportData = () => {

        if (+fiscalYearId === 0) {
            lzNotifyErrorMessageFromResult("Please select a fiscal year!");
            return;
        }

        setIsLoading(true);
        wtApiCall(
            'reports/sales_target_report',
            {
                fiscal_year_id: fiscalYearId
            },
            'get',
            (response) => {

                //set data
                if (response !== null) {
                    if (response.data !== null) {
                        //Set initial values
                        setSalesTargetReportData(response.data);
                    }
                }

                setIsLoading(false);
            },
            (error) => {
                lzNotifyErrorMessageFromResult(error);
                setIsLoading(false);
            },
        );

    };
    const exportToExcel = () => {
        setIsLoading(true);
        wtApiPostWithContentTypeHandling('reports/sales_target_report/export', { data: salesTargetReportData });
        setIsLoading(false);
    }


    return (
        <div className='container-fluid' style={{
            padding: "1em", backgroundColor: "white", minHeight: "100vh", fontFamily: "Helvetica",
        }}>
            <Form
                layout={'vertical'}
                form={form}
                onFinish={getReportData}
                style={{ maxWidth: "100%", margin: '0 auto' }}
            >
                <Card title={<span style={{ fontSize: '22px', marginLeft: "40%" }}>{companyName + " Sales Target"}</span>} style={{ width: "100%" }}>

                    <Row gutter={[24, 24]}>

                        <Col xs={15} sm={10} md={4}>
                            <label>Branch:</label>
                            <WidgetFiscalYearSelector
                                size='md'
                                value={fiscalYearId}
                                displayValue={fiscalYearName}
                                fiscalYears={fiscalYears}
                                onChange={(values) => changeValues('fiscal_year_id', values)}
                                reloadDropdownData={(values) => Base.dropdownData('fiscal_years', {}, [setFiscalYears], 1)}
                                showCloudIcon={true}
                            />

                        </Col>

                        <Col xs={12} sm={8} md={5}>
                            <Button style={{ marginTop: 30, marginRight: 5 }} type="primary" htmlType="submit" disabled={isLoading ? true : false}>Search</Button>
                            <Button style={{ marginTop: 30, backgroundColor: "#4BB543", color: "#fff" }} onClick={exportToExcel} disabled={isLoading ? true : false}>Export</Button>
                            <Button style={{ marginTop: 30, backgroundColor: "red", color: "#fff" }} onClick={print} disabled={isLoading ? true : false}>Print</Button>

                        </Col>
                    </Row>

                    <br />
                    <div style={{ width: "100%" }}>
                        <Table
                            columns={salesTargetReportHeaderColumns}
                            dataSource={salesTargetReportData}
                            pagination={false}
                            bordered
                            size="small"
                            scroll={{ x: 2000, y: 400 }}
                            virtual={true}
                            loading={{ indicator: <div><Spin /></div>, spinning: isLoading }}
                        />
                    </div>
                </Card>
            </Form>
        </div >
    );
};

export default SalesTargetReport;
